// ©2024 Austin App House. All rights reserved.
import React, {useState} from "react";

const NewMessage = ({sendMessage}) => {
    const [message, setMessage] = useState('');
    return (
        <>
            <div className="field_row">
                <div className="field_name">
                    Message
                </div>
            </div>
            <div className="field_row">
                <div className="field_block">
                    <textarea
                        className="dashboard-input dashboard-input--textarea"
                        value={message}
                        onChange={ event => setMessage(event.target.value) }
                    />
                </div>
            </div>
            <div className="modal_footer">
            <button
                type="button"
                className="dashboard-btn dashboard-btn--primary"
                onClick={(e) => {
                    e.stopPropagation();
                    setMessage('');
                    sendMessage(message)}}
            >
                Send
            </button>
            </div>

        </>
    )
}

export default NewMessage;
